


















import RingLoader from './RingLoader.vue';
import Vue from 'vue'
import * as Sentry from '@sentry/vue';
export default Vue.extend({
    name: 'AppLoader',
    components: {
        RingLoader,
    },
    computed: {
        enableAdvanceOption() {
            return this.$store.state.loaderCount === 0 && (this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive)
        },
    },
    methods: {
        reload() {
            Sentry.captureMessage(`Force reload app - Last refreshed: ${localStorage.getItem('lastRefresh')}`)
            localStorage.clear()
            sessionStorage.clear()
            document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            window.location.reload()
        },
    },
})

